import React from "react";
import { useSelector } from "react-redux";

import StepsMultiColumn from "../../../components/StepsMultiColumn";
import { isLoadingGeneralSelector } from "../../../services/general/selectors";
import useIframesActions from "../hooks/useIframesActions";
import IFramesTabs from "../../../components/IFramesTabs";
import useStepThree from "../hooks/useStepThree";
import TemplatesFooter from "../../../components/TemplatesFooter";
import useFooterActions from "../hooks/useFooterActions";
import CommandsWrapper from "../../../templates/CommandsWrapper";
import useHighlightElements from "../hooks/useHighlightElements";

import SelectorsBlock from "./SelectorsBlock";
import HeaderCommands from "./HeaderCommands";

const StepThreeConfigurator = () => {
    const isLoading = useSelector(isLoadingGeneralSelector);
    useStepThree();
    useHighlightElements();

    const {
        handleClickPrevState,
        handleClickNextState,
        handleClickSave
    } = useFooterActions();

    const {
        handleLoadedIFrames,
        handleSetCurrentIframeRef,
        handleSetCurrentIframeWrapperRef,
        handleElementClick
    } = useIframesActions();

    return (
        <StepsMultiColumn
            isLoading={isLoading}
            controls={(
                <CommandsWrapper
                    header={(
                        <HeaderCommands />
                    )}
                    body={(
                        <SelectorsBlock />
                    )}
                    footer={(
                        <TemplatesFooter
                            onClickPrevState={handleClickPrevState}
                            onClickNextState={handleClickNextState}
                            onSave={handleClickSave}
                        />
                    )}
                />
            )}
            iframes={(
                <IFramesTabs
                    onLoaded={handleLoadedIFrames}
                    setCurrentIframeRef={handleSetCurrentIframeRef}
                    setCurrentIframeWrapperRef={handleSetCurrentIframeWrapperRef}
                    onElementClick={handleElementClick}
                />
            )}
        />
    );
};

export default StepThreeConfigurator;
